/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/254-sleepy': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M8 16A8 8 0 108 0a8 8 0 000 16zM8 1.5a6.5 6.5 0 110 13 6.5 6.5 0 010-13z"/><path pid="1" d="M10 10.5c0 1.381-.895 2.5-2 2.5s-2-1.119-2-2.5S6.895 8 8 8s2 1.119 2 2.5zM6.5 5.313a.502.502 0 01-.354-.146c-.302-.302-.991-.302-1.293 0a.5.5 0 01-.707-.707c.696-.696 2.011-.696 2.707 0a.5.5 0 01-.354.853zM11.5 5.313a.502.502 0 01-.354-.146c-.302-.302-.991-.302-1.293 0a.5.5 0 01-.707-.707c.696-.696 2.011-.696 2.707 0a.5.5 0 01-.354.853z"/>'
  }
})
